export default __webpack_public_path__ + "static/media/facareta.b55cc698.png";